import _extends from "@babel/runtime/helpers/esm/extends";
import { css } from 'styled-components';

/**
 * Defines the toggle size according to the size property.
 * Check this figma link for more details: https://www.figma.com/file/2D5oejKfR6yZJ3Qh6ZHgmu/00.-Tractor---Foundation-(WIP)?node-id=615%3A296
 */
export var makeToggleSize = function makeToggleSize(_ref) {
  var size = _ref.size,
      checked = _ref.checked,
      theme = _ref.theme;
  var toggleSize = theme.toggle.sizes[size];
  var circleSize = theme.toggle.circleSizes[size];
  return _extends({}, toggleSize, {
    ':after': _extends({}, circleSize, {
      left: checked ? "calc(100% - " + circleSize.width + " - " + toggleSize.padding + ")" : toggleSize.padding
    })
  });
};
export var makeToggleColor = function makeToggleColor(_ref2) {
  var checked = _ref2.checked,
      disabled = _ref2.disabled,
      theme = _ref2.theme,
      error = _ref2.error;

  if (disabled) {
    return css(["background-color:", ";:after{background-color:", ";}"], theme.colors.grey.base, theme.colors.grey.light);
  }

  if (error) {
    return css(["background-color:", ";:after{background-color:", ";}:hover{background-color:", ";}:focus-within{border-color:", ";}"], theme.colors.red.dark, theme.colors.base.white, theme.colors.red.darker, theme.colors.red.darker);
  }

  if (checked) {
    return css(["background-color:", ";:after{background-color:", ";}:hover{background-color:", ";}:focus-within{border-color:", ";}"], theme.colors.primary.base, theme.colors.base.white, theme.colors.primary.dark, theme.colors.primary.dark);
  }

  return css(["background-color:", ";:after{background-color:", ";}:hover{background-color:", ";}:focus{border-color:", ";}"], theme.colors.grey.base, theme.colors.base.white, theme.colors.grey.darker, theme.colors.primary.base);
};